import {Route, Redirect, Switch} from "react-router-dom";
import Login from "../pages/auth/Login";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";

export default function Auth() {
    return (
        <Switch>
            <Route path="/auth/login" component={Login}/>
            <Route path="/auth/forgot-password" component={ForgotPassword}/>
            <Route path="/auth/reset-password" component={ResetPassword}/>
            <Redirect from="/auth" exact={true} to="/auth/login"/>
            <Redirect to="/auth/login"/>
        </Switch>
    );
}
